import React from "react";
import { Button, Card, Section } from "../../Components";
import { FAQ, Notice, Security } from "../../Components/PageSections";
import App from "../../Layouts/AppLayout";

export default function Seller() {

  const steps = [
    {
      image: 'sign-up',
      head: '1. Sign Up',
      body: 'Create a payment link by signing into your PayOnDelivery account. Send the offer to the buyer to complete the transaction',
    },
    {
      image: 'shipping-fast',
      head: '2. Order Pick Up',
      body: "Item is picked from your location and delivered to the buyer's location within 24hours.",
    },
    {
      image: 'credit-card',
      head: '3. Get Paid',
      body: "Once the item is delivered, your payment will be released which will hit your account within 24h or less.",
    },
  ]

  const podFeatures = [
    {
      head: "Get A Free Web Store",
      body: "A free store front where you can upload all your items for sale which enables you to reach more customers and grow your sales exponentially. With POD, you can ensure customers trust your brand, removing the hassle of the fear of 'what I got, vs what I ordered'."
    },
    {
      head: "Individual Product Link",
      body: "For each product you create, you get a link that you can post and share particularly for that product. This allows for flexibility in many cases. For instance, if you want to put one or two products on sale."
    },
    {
      head: "Get To Become A POD Seller Partner",
      body: "Make more money as you sell with The POD Seller Partner program."
    },
    {
      head: "Get Paid Within 24 Hours",
      body: "Once a buyer confirms delivery, you will receive your payment. Buyers have 24 hours to confirm delivery, but if they don’t take action within that time, POD steps in to release the payment to the seller anyway."
    },
    {
      head: "Managing Logistic Operations Effortlessly",
      body: "All you need to do is to tell us where to pick up the item the customer wants to buy and we will deliver to your customer. The delivery fee is paid by the buyer."
    },
    {
      head: "Social Media Integration (Coming Soon)",
      body: "An easy integration that will allow sellers to connect their social accounts with PayOnDelivery to increase trust, transparency and credibility and thereby increasing sales."
    }
  ];

  const [faqs, setFaqs] = React.useState([]);

  React.useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch('/help-center-data/seller');
        const data = await response.json();
        setFaqs(data);
      } catch (e) {}
    };

    fetchFaqs();
  }, []);

  const Feature = ({ feature }) =>
    <Card
      className="tw-border tw-border-gray-300 !tw-p-4"
      style={{
        border: '1px solid #6d60f6',
      }}
    >
      <p className="tw-mb-2 tw-font-medium">
        {feature.head}
      </p>
      <p>{feature.body}</p>
    </Card>

  const [text, setText] = React.useState('More')
  const [inputValue, setInputValue] = React.useState('')
  const [index, setIndex] = React.useState(0)

  React.useEffect(() => {
    const texts = ['More', 'Faster']

    const interval = setInterval(() => {
      setIndex(prevIndex => {
        const newIndex = prevIndex + 1 >= texts.length ? 0 : prevIndex + 1
        setText(texts[newIndex])
        return newIndex
      })
    }, 10000)

    return () => clearInterval(interval)
  }, [])

  return (
    <App>
      <Section
        pad={false}
        className="tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-4 md:tw-gap-8 lg:tw-gap-16 lg:tw-flex-row tw-pt-8"
      >
        <div className="tw-space-y-8">
          <h1 className="h1-head tw-text-black">
            Sell <span className="tw-text-secondary tw-animate-textSlide">{text}</span>  With PayOnDelivery.Com
          </h1>

          <p>Get paid within 24h when you sell with {' '}
            <span className="tw-relative">
              PayOnDelivery.com
              <img src="/assets/images/underline.png" alt="PayOnDelivery" className="tw-absolute tw--bottom-4 tw-right-0 tw-w-full" />
            </span>
          </p>

          <div className="tw-flex md:tw-inline-flex tw-flex-col md:tw-flex-row sm:border-off md:border-on tw-rounded-full tw-p-1 tw-gap-2 md:tw-gap-1">
            <input
              className="sm:border-on md:border-off tw-rounded-full tw-outline-none p tw-px-5 tw-py-3 tw-mb-2"
              placeholder="What are you selling?"
              onChange={(e) => setInputValue(e.target.value)}
            />

            <Button
              title={'Start selling'}
              illustrated
              href={`/create-link?name=${inputValue}`}
            />
          </div>
        </div>

        <img
          src="/assets/images/pod-hand-holding-mockup.png"
          alt="POD: The fastest, most trusted way to buy and sell online."
          className="tw-z-10 tw-h-auto tw-min-w-full fococlipping tw-max-w-full"
        />
      </Section>

      <Notice />

      <Section className="tw-space-y-8">
        <div>
          <h3 className="tw-text-black">Sell With PayOnDelivery.Com</h3>
          <p>Sell anything with PayOnDelivery.com in 3 simple steps</p>
        </div>

        <div className="tw-grid md:tw-grid-cols-3 tw-gap-4 md:tw-gap-8 lg:tw-gap-16">
          {steps.map((item, index) => (
            <div key={index}>
              <div style={{ border: '1px solid #6d60f6' }} className="tw-rounded-full tw-p-4 md:tw-p-8 tw-mb-2 md:tw-mb-4 tw-inline-block">
                <img loading="lazy" src={`/assets/images/icons/${item.image}.png`} className="from20-32" />
              </div>
              <h5 className="md:tw-mb-4">{item.head}</h5>
              <p>{item.body}</p>
            </div>
          ))}
        </div>

        <div className="tw-w-full">
          <Button href={'/create-link'} className="tw-w-full md:tw-w-auto">Get Started</Button>
        </div>
      </Section>

      <Section className="tw-space-y-8 tw-pt-8 md:tw-pt-16" pad={false}>
        <div>
          <h3 className="tw-text-black">Why sell with POD?</h3>
          <p>Why you should list and sell your items/products on POD</p>
        </div>

        <div className="tw-grid md:tw-grid-cols-3 tw-gap-6 md:tw-gap-8 tw-items-end tw-justify-end">
          <div className="tw-space-y-6 tw-pb-0 md:tw-pb-16">
            {podFeatures.slice(0, 3).map((feature, index) => <Feature feature={feature} key={index} />)}
          </div>

          <img
            src="/assets/images/pod-left-hand-with-vitiligo-holding-mockup.png"
            alt="Phone displaying POD features"
            className="tw-w-full tw-hidden md:tw-flex"
          />

          <div className="tw-space-y-6 tw-pb-8 md:tw-pb-16">
            {podFeatures.slice(3, 6).map((feature, index) => <Feature feature={feature} key={index} />)}
          </div>
        </div>
      </Section>

      <div style={{ background: '#EEFFF7' }}>
        <Section className="tw-grid md:tw-grid-cols-5 tw-gap-4 md:tw-gap-8 lg:tw-gap-16">
          <div className="md:tw-col-span-3 tw-space-y-4">
            <h3 className="tw-text-black">Sell Anywhere in Nigeria With PayOnDelivery.</h3>
            <p>
              On PayOnDelivery, you don't have to worry about
              logistics. We take care of that for you.
              PayOnDelivery has partnered with trusted logistic
              companies. We give the buyers different delivery
              options. This allows you sell faster and
              confidently!
            </p>

            {['Tested & Trusted', 'Safe & Secure', 'Fast & Reliable'].map(
              (item, index) => (
                <div key={index} className="tw-ml-4 md:tw-ml-8 tw-flex tw-items-center tw-gap-4 tw-mb-4">
                  <img loading="lazy" src={`/assets/images/icons/done.svg`} className="size-15px" />
                  <p>{item}</p>
                </div>
              )
            )}
          </div>

          <Card className="md:tw-col-span-2 tw-flex tw-flex-col tw-items-center tw-gap-4 md:tw-gap-8" style={{background: '#A3DBC0'}}>
            <img
              src="/assets/images/delivery-bike.png"
              alt="Delivery Integration"
              height={200}
              width={200}
              className="size-250px"
            />

            <div className="tw-w-full tw-grid tw-grid-cols-2 tw-gap-4 md:tw-gap-8 tw-p-4">
              {['/assets/partners/gokada.png', '/assets/partners/fex.png'].map((_, i) =>
                <div className="tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-py-2 tw-px-4" key={i}>
                  <img src={_} className="tw-w-auto" style={{height: '32.3px'}} />
                </div>
              )}
            </div>
          </Card>
        </Section>
      </div>

      <FAQ questions={faqs} />

      <Security
        head="A Secure way to get paid as a Nigerian seller"
        body="Join over 1200+ active Nigerian sellers who use PayOnDelivery.com to sell online. With PayOnDelivery.com, your payment is guaranteed. The buyer's payment is held to cover the purchase and either accepts or returns the item safely to you."
      />
    </App>
  );
}
